export default {
    noEmojiOptionsAvailable: 'No emoji options available',
    previousQuestion: 'Previous Question',
    nextQuestion: 'Next Question',
    submit: 'Submit evaluation',
    skipThisQuestion: 'Skip this question',
    addCommentOptional: 'Add a comment (optional)',
    addAnComment: 'Add a comment',
    typeYourComment: 'Type your comment',
    commentDetailsPlaceholder: 'Provide as much details as possible',
    ariaPreviousQuestion: 'Go to previous question',
    ariaNextQuestion: 'Go to next question',
    ariaSubmit: 'Submit evaluation',
    ariaSkipQuestion: 'Skip this question',
    submitConfirm: {
        title: 'Confirm your submission',
        message: 'This is the final question. Skipping it will submit your evaluation immediately.',
        confirm: 'Submit evaluation',
    },
    confidentiality: {
        noResults:
            'Your responses are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated does not see any results: a summary will be presented to them.',
        scoresOnly:
            'Your responses are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated only sees the aggregated scores from all reviewers. They do not see any written comments, and a summary of the results will be presented to them.',
        scoresAndComments:
            'Your responses, scores and comments included, are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated does not see your responses.',
    },
    progression: 'Progression',
    surveyAnswer: {
        featureItem: {
            title: 'Share your feedback',
            description:
                'We would like to gather your comments about the collaboration with your colleagues. Your answers will be <bold>visible to the {{managerLabel}} of the person being evaluated</bold>. The employee being evaluated will not see your responses.',
        },
        reviewedCollegue: 'Reviewed employee',
        selfEvaluationTitle: 'Your Self-Evaluation',
        selfEvaluationDescription:
            'This is the time to step back and reflect on your journey. Your reflections will fuel a rich discussion with your {{managerLabel}} and help you chart the path ahead. Be authentic, your voice matters.',
        selfEvaluationPill: 'Self-evaluation',
    },
    validation: {
        atLeastOneOptionRequired: 'Please select at least one option',
        minThreeCharacters: 'Please enter at least 3 characters',
        ratingRequired: 'Please select a rating',
        allOptionsMustBeRanked: 'Please rank all options',
        otherOptionRequired: 'Please enter your "Other" option answer',
        maxChoicesReached:
            'You have already reached the maximum number of choices in this question, please unselect one to add a new one.',
    },
    otherOption: {
        placeholder: 'Please input your option here',
        charLimitTooltip: 'Please write an option of less than 50 characters.',
    },
};
